import { render, staticRenderFns } from "./CapitalFlow.vue?vue&type=template&id=5c5dd557&scoped=true"
import script from "./CapitalFlow.vue?vue&type=script&lang=js"
export * from "./CapitalFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dd557",
  null
  
)

export default component.exports